import React from 'react';
import Auxw from '../../../hoc/Auxw';
import Button from '../../UI/Button/Button';



const orderSummary = (props) => {
	const ingredientSummary = Object.keys(props.ingredients)
		.map(igKey => (
			<li key={igKey}>{igKey[0].toUpperCase() + igKey.slice(1)} : {props.ingredients[igKey]}</li>
		))
	
	return (
		<Auxw>
			<h3>Your Order</h3>
			<p>A delicious burger with the following ingredients: </p>
			<ul>
				{ingredientSummary}
			</ul>
			<p><strong>Total Price: {props.price.toFixed(2)}</strong></p>
			<p>Continue to Checkout?</p>
			<Button
				clicked={props.purchaseCanceled}
				btnType="Danger">CANCEL</Button>
			<Button
				clicked={props.purchaseContinued}
				btnType="Success">CONTINUE</Button>
		</Auxw>);
};

export default orderSummary;


// WEBPACK FOOTER //
// ./src/components/Burger/OrderSummary/OrderSummary.js